import { Component } from "react"

/* Modal */
import Modal from "react-modal"

/* Translate */
import { t } from "../translates/translate"

/* Icons */
import { WarningIcon, QuestionIcon, InfoIcon, CheckIcon } from "./Icons"


/* ICON OF EVERY TYPE */
const ICONS = {
    warning: WarningIcon,
    error: WarningIcon,
    question: QuestionIcon,
    success: CheckIcon,
    info: InfoIcon,
}


/* THE MOUNTED HOST — THE HELPER ASKS THROUGH IT */
let host = null


/* ASK A CONFIRMATION FROM ANYWHERE (helpers/alert.js) — RESOLVES true OR false */
export const pushConfirm = (options) => new Promise((resolve) => {

    /* Check Host */
    if (!host) {
        resolve(false)
        return
    }

    /* Ask */
    host.open(options, resolve)
})


/* Component Confirm */
class Confirm extends Component {

    constructor() {
        super()

        this.state = {
            visible: false,
            title: "",
            text: "",
            icon: "warning",
            danger: false,
            confirmText: "",
            cancelText: "",
        }

        /* The pending promise callback */
        this.resolve = null
    }

    componentWillUnmount = () => {
        host = null
    }

    componentDidMount = () => {
        host = this
    }

    /* Open Action */
    open = (options, resolve) => {

        /* Keep The Callback */
        this.resolve = resolve

        /* Show */
        this.setState({
            visible: true,
            title: options.title ? options.title : "",
            text: options.text ? options.text : "",
            icon: ICONS[options.icon] ? options.icon : "question",
            danger: options.danger === true,
            confirmText: options.confirmText ? options.confirmText : t("common.yes"),
            cancelText: options.cancelText ? options.cancelText : t("common.cancel"),
        })

    }

    /* Close Action — answer is passed to the waiting promise */
    close = (answer) => {

        /* Fields */
        const resolve = this.resolve

        /* Release The Callback */
        this.resolve = null

        /* Hide */
        this.setState({ visible: false })

        /* Answer */
        if (resolve) {
            resolve(answer)
        }

    }

    render = () => {

        /* Fields */
        const { visible, title, text, icon, danger, confirmText, cancelText } = this.state

        /* Type Icon */
        const TypeIcon = ICONS[icon]

        return (
            <Modal isOpen={visible}
                onRequestClose={() => this.close(false)}
                closeTimeoutMS={200}
                className="confirm--modal"
                overlayClassName="confirm--overlay">

                {/* Icon */}
                <div className={`confirm--icon ${danger ? "danger" : icon}`}>
                    <TypeIcon size={26} />
                </div>

                {/* Title */}
                {title ? <div className="confirm--title" dangerouslySetInnerHTML={{ __html: title }} /> : null}

                {/* Text */}
                {text ? <div className="confirm--text" dangerouslySetInnerHTML={{ __html: text }} /> : null}

                {/* Buttons */}
                <div className="confirm--footer">

                    <div onClick={() => this.close(false)} className="confirm--button ghost">
                        {cancelText}
                    </div>

                    <div onClick={() => this.close(true)} className={`confirm--button ${danger ? "danger" : "primary"}`}>
                        {confirmText}
                    </div>

                </div>

            </Modal>
        )
    }

}

export default Confirm
